/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle
}  from "react";
import { GoSellElements } from "@tap-payments/gosell";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Snackbar } from "@mui/material";
import MuiAlert from "@material-ui/lab/Alert";
import { RootState } from "../store/reducers";
import { setCookie } from "../helper/cookieFunction";

function Alert(props:any) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}





const GoSellEle = forwardRef((props:any, ref) => {
  const { setTapId, status, paymentMethod, setButtonLoading, setCardDetails} = props;
  const apiState = useSelector((state: RootState) => state.apiReducer);

  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });

  const [credToken, setCredToken] = useState("");
  // const data = {
  //   amount: parseFloat(inpValue),
  //   currency: "KWD",
  //   threeDSecure: true,
  //   save_card: false,
  //   description: "Test Description",
  //   statement_descriptor: "Sample",
  //   metadata: {
  //     udf1: "test 1",
  //     udf2: "test 2",
  //   },
  //   reference: {
  //     transaction: "txn_0001",
  //     order: "ord_0001",
  //   },
  //   receipt: {
  //     email: false,
  //     sms: true,
  //   },
  //   customer: {
  //     first_name: appState.loggedIn
  //       ? appState.userInfo.name
       
  //       : null,
  //     email: appState.loggedIn
  //       ? appState.userInfo.email
       
  //       : null,
  //     phone: {
  //       country_code: "965",
  //       number: appState.loggedIn
  //         ? parseFloat(appState.userInfo.mobile_no)
          
  //         : null,
  //     },
  //   },
  //   merchant: {
  //     id: "",
  //   },
  //   source: {
  //     id: "src_kw.knet",
  //   },
  //   post: {
  //     url: `${window.location.href}`,
  //   },
  //   redirect: {
  //     url: `${window.location.href}`,
  //   },
  // };

  useImperativeHandle(ref, () => ({
    submitRequest() {
      // setButtonLoading(true)
      GoSellElements.submit();
    },
  }));

  // const callbackFunc = async (response:any) => {
  //   if (paymentMethod == "card") {
  //      await response?.id;
  //     setTapId(response.id);
  //   } else {
  //     setCredToken(response.id);
  //     setCookie("cardToken", JSON.stringify(response.id), 364);
  //   }
  // };

  const callbackFunc = async (response:any) => {
    console.log(response);
    if (paymentMethod == "card") {
      let res = await response?.id;
      // console.log(response);
      let cardDetails = {
        first_eight_digits: response?.card?.first_eight,
      }
      console.log(response?.card , cardDetails , "cardDetails");
      setCardDetails(response?.card ? cardDetails : null);
      setTapId(response.id);
    } else {
      // console.log(response, "// console cred");
      setCredToken(response.id);
      setCookie("cardToken", JSON.stringify(response.id), 364);
    }
  };
  // const handleLogout = () => {
  //   appDispatch({ type: "logout" });
  // };

 
  useEffect(() => {
    // const getResponse = async () => {
    //   try {
    //     // console.log("cred", credToken);
    //     const newReq = await Axios.post(
    //       "${process.env.REACT_APP_API_URL}/customer/save_card",
    //       {
    //         card_id: credToken,
    //       },
    //       {
    //         headers: {
    //           Authorization: `Bearer ${getCookie("tokenAuth")}`,
    //         },
    //       }
    //     );
    //     // console.log("getREsponse");

    //     // console.log(newReq);
    //     appDispatch({
    //       type: "updatedCardList",
    //       cardList: newReq.data.data,
    //     });
    //     setAlertMessage({
    //       open: true,
    //       message: newReq.data.data.message,
    //       alertSuccess: newReq.data.data.success,
    //     });
    //   } catch (e) {
    //     Promise.reject(e);
    //     if (e == undefined) {
    //       appDispatch({
    //         type: "SHOW_ALERT",
    //         alertType: "warning",
    //         message: "Please check your network.",
    //       });
    //     } else {
    //       appDispatch(handleError(e));
    //     }
    //     if (e.response.status == 401) {
    //       handleLogout();
    //     }
    //   }
    // };
    // // // console.log('running........................')
    // if (credToken !== "" && credToken !== null && credToken !== undefined) {
    //   // setButtonLoading(true)
    //   getResponse();
    // } else {
    //   // setAlertMessage({ open: true, message: "There is some error while processing your request. Please check your details and try again", alertSuccess: false })
    //   // setButtonLoading(false)
    // }
  }, [credToken]);

  // }

  useEffect(() => {
    // console.log(appState.storeInfo.tapKey,"tap KEys")
  }, []);

  return (
    <div className="App">
      {/* {paymentMethod === "Master" || paymentMethod === "CREDIT" ? */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>
      <div>
        <GoSellElements
          gateway={{
            publicKey: status == "checkout" ? apiState.storeInfo.tapKey : 'pk_test_86hEIwQToAH0ZbqFYNtfKGCX',
            language: "en",
            supportedCurrencies: "all",
            supportedPaymentMethods: "all",
            notifications: "msg",
            callback: callbackFunc,
            saveCardOption: true,
            labels: {
              cardNumber: "Card Number",
              expirationDate: "MM/YY",
              cvv: "CVV",
              cardHolder: "Name on Card",
              actionButton: "Pay",
            },
            style: {
              base: {
                color: "#535353",
                lineHeight: "18px",
                fontFamily: "sans-serif",
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                  color: "rgba(0, 0, 0, 0.26)",
                  fontSize: "15px",
                },
              },
              invalid: {
                color: "red",
                iconColor: "#fa755a ",
              },
            },
          }}
        />

        <p id="msg"></p>
      </div>
      {/* <button style={{display: 'none'}} onClick={submitRequest}>Submit</button> */}
      {/* <button onClick={getResponse}>Check Respose</button> */}
      {/* <button >Check Respose</button> */}
    </div>
  );
});
export default GoSellEle;
